module.exports = __webpack_public_path__ + "static/media/Knob3.e375ada4.png";